import { Component } from '@angular/core';

import { NavItemComponent } from './nav-item.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NavItem } from '../../models';
import { NavService } from '../services/nav.service';
import { ClaytonLogoComponent } from '../../clayton-logo/clayton-logo.component';
import { MatIcon } from '@angular/material/icon';
import { MatToolbar } from '@angular/material/toolbar';
import { VersionService } from '../../services/version.service';

@Component({
  selector: 'nav-bar',
  imports: [NavItemComponent, MatSidenavModule, ClaytonLogoComponent, MatIcon],
  template: `
    <mat-sidenav-container hasBackdrop="false" class="container">
      @if (!hideNavbar) {
        <mat-sidenav class="navbar" mode="side" position="start" opened>
          <!-- logo component -->
          <clayton-logo id="logo-container"></clayton-logo>
          @if (navItems && navItems.length > 0) {
            @for (item of navItems; track item) {
              <nav-item
                [name]="item.Name"
                [active]="item.Active"
                [iconUrl]="item.IconUrl"
                [url]="item.Url"
                [navbarHidden]="hideNavbar"
              ></nav-item>
            }
          }
          <div class="versionInfo">
            <p>Version:</p>
            <p>{{ version }}</p>
            @if (sha) {
              <p>SHA: {{ sha }}</p>
            }
          </div>
          <div class="sidebar">
            <div class="hide">
              <button
                style="background: transparent; width: 1px;"
                (click)="closeNavbar()"
              >
                <mat-icon>keyboard_double_arrow_left</mat-icon>
              </button>
            </div>
          </div>
        </mat-sidenav>
      } @else {
        <mat-sidenav class="hidden-nav" mode="side" opened>
          <clayton-logo
            id="logo-container"
            [navbarHidden]="hideNavbar"
          ></clayton-logo>
          <ng-container>
            @for (item of navItems; track item) {
              <div>
                <nav-item
                  [name]="item.Name"
                  [active]="item.Active"
                  [iconUrl]="item.IconUrl"
                  [url]="item.Url"
                  [navbarHidden]="hideNavbar"
                ></nav-item>
              </div>
            }
          </ng-container>
          <div class="sidebar open">
            <button
              style="background: transparent; width: 0.0625em"
              (click)="openNavbar()"
            >
              <mat-icon>keyboard_double_arrow_right</mat-icon>
            </button>
          </div>
        </mat-sidenav>
      }
      <mat-sidenav-content>
        <ng-content></ng-content>
      </mat-sidenav-content>
    </mat-sidenav-container>
  `,
  styles: [
    `
      .container {
        height: 100vh;
      }
      .versionInfo {
        text-align: center;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        height: 95px;
        width: 100%;
        bottom: 0;
        position: absolute;
        background: none;

        color: var(--nav-item-text-color);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-bottom: 50px;
      }
      .navbar {
        //box-shadow: var(--box-shadow);
        width: 150px;
        background: var(--nav-menu-background);
        overflow-y: auto;

        #logo-container {
          display: flex;
          position: relative;
          justify-content: center;
          align-items: center;
          margin: 0 auto;

          width: 100%;
          height: 70px;
        }
      }

      .sidebar {
        float: right;
        position: absolute;
        bottom: 0;
      }

      .hide {
        float: right;
        position: absolute;
        left: 104px;
        bottom: 0;
      }

      .open {
        left: 30px;
      }

      .hidden-nav {
        overflow-y: auto;
        width: 71px;
        background: var(--nav-menu-background);
      }
    `,
  ],
})
export class NavBarComponent {
  navItems: NavItem[] = [];

  hideNavbar: boolean = false;
  version: string = '';
  sha: string = '';

  constructor(
    private navService: NavService,
    private versionService: VersionService,
  ) {
    this.navService.navItems$.subscribe((i) => {
      this.navItems = i;
    });
    const version = versionService.getVersion();

    if (version.includes('@')) {
      [this.version, this.sha] = version.split('@');
    } else {
      this.version = version;
    }
  }

  closeNavbar() {
    this.hideNavbar = true;
  }

  openNavbar() {
    this.hideNavbar = false;
  }
}
